export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
  ) {
    super(
      status === 409
        ? `${message} Запис змінився. Оновлюємо дані. Перевірте зміни та повторіть спробу.`
        : status === 403 && !/прав|дозвол|доступ/iu.test(message)
          ? `${message} Немає дозволу на цю дію.`
          : message,
    )
    if (status === 409 && typeof window !== 'undefined')
      window.dispatchEvent(new Event('crm:conflict'))
  }
}

export const apiFailure = (message: string, status: number, code: string) =>
  new ApiError(message, status, code)

export const reportRefreshFailure = () => {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('crm:refresh-failed'))
}

interface ApiEnvelope<T> {
  ok: boolean
  data?: T
  error?: { code: string; message: string }
}

export const api = async <T>(path: string, init?: RequestInit): Promise<T> => {
  let response: Response
  try {
    response = await fetch(`/api${path}`, {
      ...init,
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...init?.headers },
    })
  } catch {
    throw new ApiError('Немає зв’язку із сервером. Спробуйте ще раз.', 0, 'NETWORK_ERROR')
  }
  let body: ApiEnvelope<T>
  try {
    body = (await response.json()) as ApiEnvelope<T>
  } catch {
    throw new ApiError(
      'Сервер тимчасово недоступний. Спробуйте ще раз.',
      response.status,
      'INVALID_RESPONSE',
    )
  }
  if (!response.ok || !body.ok) {
    throw new ApiError(
      body.error?.message ?? 'Не вдалося виконати запит',
      response.status,
      body.error?.code ?? 'REQUEST_FAILED',
    )
  }
  return body.data as T
}
